import Box from "@mui/material/Box";
import { cleanProps } from "../internal/cleanProps";
import { tokens } from "../tokens";
import type { BulletListProps } from "../types";

/** ADR-20261102-h2fd: H2's dialog list -- discs, 17px ink, 4px apart, 24px beneath. */
export function BulletList({ items, testId }: Readonly<BulletListProps>) {
  return (
    <Box
      component="ul"
      {...cleanProps({ "data-testid": testId })}
      sx={{
        listStyle: "disc",
        margin: 0,
        marginBottom: `${tokens.spacing.lg}px`,
        padding: "0 0 0 20px",
        display: "flex",
        flexDirection: "column",
        gap: "4px",
        fontSize: 17,
        color: tokens.colour.neutral.ink,
      }}
    >
      {items.map((item) => (
        <Box component="li" key={item.key} sx={{ lineHeight: 1.4 }}>
          {item.text}
        </Box>
      ))}
    </Box>
  );
}
